<div class="dq-settings-container">
  <p>Data Quality Checks will be disabled for selected buyer and supplier</p>

  <div class="controls-section">
    <div class="row">
      <!-- Buyer Selection -->
      <div class="form-group col-md-6">
        <label for="buyerName">Select Buyer:</label>
        <ps-ui-select-dropdown
          [formControl]="buyerControl"
          [enableSearch]="true"
          [dropdownItems]="buyers"
          [field]="'name'"
          [label]="getBuyerName(buyerControl.value) || 'Select Buyer'"
          labelNone="Select Buyer"
          (selectedItem)="selectBuyer($event)"
        >
        </ps-ui-select-dropdown>
      </div>

      <!-- Supplier Selection (Multi Select) -->
      <div class="form-group col-md-6">
        <label for="supplierName">Select Suppliers:</label>
        <ps-ui-select-dropdown
          [formControl]="suppliersControl"
          [enableSearch]="true"
          [multi]="true"
          [dropdownItems]="suppliers"
          [field]="'name'"
          [label]="getSelectedSuppliersLabel()"
          labelNone="Select Suppliers"
          (selectedItem)="selectSuppliers($event)"
        >
        </ps-ui-select-dropdown>
      </div>
    </div>

    <!-- Actions Buttons -->
    <div class="hasing-buttons mt-6 col-md-6">
      <button
        type="button"
        color="primary"
        class="btn-add"
        (click)="addCombination()"
        [disabled]="
          buyerControl.invalid || suppliersControl.value?.length === 0
        "
      >
        {{ isEditing ? 'Update' : 'Add Combination' }}
      </button>
    </div>
  </div>

  <hr />

  <div
    class="table-dataQuality table-responsive"
    *ngIf="savedCombinations.length > 0"
  >
    <p>Buyer and supplier</p>
    <table>
      <thead>
        <tr>
          <th>Buyer</th>
          <th>Suppliers</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let combo of savedCombinations;
            let i = index;
            trackBy: trackByBuyerId
          "
        >
          <td>
            <strong>{{ getBuyerName(combo.buyerId) }}</strong>
            <span class="font-weight-light"> (ID: {{ combo.buyerId }})</span>
          </td>
          <td>
            <div class="selected-suppliers">
              <span
                class="supplier-badge"
                *ngFor="let supplierId of combo.supplierIds"
              >
                {{ getSupplierName(supplierId) }}
              </span>
            </div>
          </td>
          <td>
            <div class="hasing-buttons">
              <button
                type="button"
                color="primary"
                class="btn-remove"
                (click)="removeCombination(i)"
              >
                Remove
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="savedCombinations.length === 0">No buyer-supplier combinations.</p>
</div>
